const controlMenu = () => {
    const headerElement = document.querySelector('.header_immediateactions');
    const container = document.querySelector('.wp-block-navigation__responsive-container');

    // Ensure both elements exist before proceeding
    if (headerElement && container) {
        // Clone the element with all its children, attributes, etc.
        const clonedHeader = headerElement.cloneNode(true);

        // Append the clone to the target container
        container.appendChild(clonedHeader);
    } else {
        console.warn('Source or target element not found');
    }

    const openButton = document.querySelector('.wp-block-navigation__responsive-container-open');

    if (container && openButton) {
        // Use MutationObserver to monitor class changes on the container
        const observer = new MutationObserver((mutations) => {
            mutations.forEach((mutation) => {
                if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
                    if (container.classList.contains('is-menu-open')) {
                        openButton.classList.add('is-menu-open');
                    } else {
                        openButton.classList.remove('is-menu-open');
                    }
                }
            });
        });

        // Start observing class attribute changes on the container
        observer.observe(container, { attributes: true, attributeFilter: ['class'] });

        // Synchronize initial class state if already set
        if (container.classList.contains('is-menu-open')) {
            openButton.classList.add('is-menu-open');
        }
    }

    const parentMenuItems = document.querySelectorAll('.wp-block-navigation-item.has-child');

    parentMenuItems.forEach(function (item) {
        const parentLink = item.querySelector('.wp-block-navigation-item__content');

        if (parentLink) {
        parentLink.addEventListener('click', function (event) {
            // Updated to target 600px viewports and below
            if (window.innerWidth <= 767) {
            const isOpen = item.classList.contains('is-active-mobile');

            if (!isOpen) {
                event.preventDefault();
                
                // Close other open mobile submenus for accordion behavior
                parentMenuItems.forEach(element => element.classList.remove('is-active-mobile'));
                
                // Open the clicked mobile submenu
                item.classList.add('is-active-mobile');
            }
            }
        });
        }
    });
}

export { controlMenu }